import { render } from "./Buttons.vue?vue&type=template&id=53a27c4d&scoped=true"
import script from "./Buttons.vue?vue&type=script&lang=js"
export * from "./Buttons.vue?vue&type=script&lang=js"

import "./Buttons.vue?vue&type=style&index=0&id=53a27c4d&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-53a27c4d"

export default script